import { deepCopy, isEmptyList, sortByField } from "../../utils";

function TemplateOperationsListing(props) {
  const { events } = props;
  const eventsToRender = !isEmptyList(events) ? deepCopy(events) : [];
  sortByField(eventsToRender, "name");
  return (
    <div className="operation-event-listing">
      {!isEmptyList(eventsToRender) &&
        eventsToRender.map((operationEvent) => (
          <div key={operationEvent.uuid}>{operationEvent.name}</div>
        ))}
    </div>
  );
}

export default TemplateOperationsListing;
